module.exports = __webpack_public_path__ + "img/icon-caja.c8353ff4.svg";